import {
  currentTaperDraft,
  proposeTaper,
  type LocalDate,
  type PlanDraft,
  type QuitPlan,
} from '@tahi/core';

/** The plan as an edit draft, with the schedule as it stands today (so saving it unchanged adds no segment). */
export function draftFromPlan(
  plan: QuitPlan,
  today: LocalDate,
  over: Partial<PlanDraft> = {},
): PlanDraft {
  return {
    baselinePerDay: plan.baselinePerDay,
    taper: currentTaperDraft(plan.taper, today) ?? proposeTaper(plan.baselinePerDay),
    price: plan.price,
    fundId: plan.fundId,
    quitlineCountry: plan.quitlineCountry,
    ...over,
  };
}
